(function () {
  var root = document.querySelector('[data-pmg-app]');
  if (!root) return;

  var workerUrl = (root.getAttribute('data-pmg-worker-url') || '').replace(/\/$/, '');
  if (!workerUrl) return;

  var loginView = root.querySelector('[data-pmg-login]');
  var contentView = root.querySelector('[data-pmg-content]');
  var loginForm = root.querySelector('[data-pmg-login-form]');
  var loginError = root.querySelector('[data-pmg-login-error]');
  var createForm = root.querySelector('[data-pmg-create-form]');
  var createError = root.querySelector('[data-pmg-create-error]');
  var createSubmitButton = createForm.querySelector('button[type="submit"]');
  var createCountLabel = root.querySelector('[data-pmg-create-count]');
  var refreshButton = root.querySelector('[data-pmg-refresh]');
  var rowsBody = root.querySelector('[data-pmg-rows]');
  var summaryEl = root.querySelector('[data-pmg-summary]');
  var promotionFilterButtons = root.querySelectorAll('[data-pmg-filter]');
  var productSearchInput = root.querySelector('[data-pmg-product-search]');
  var productResultsEl = root.querySelector('[data-pmg-product-results]');
  var selectedProductsEl = root.querySelector('[data-pmg-selected-products]');
  var variantPicker = root.querySelector('[data-pmg-variant-picker]');
  var variantSearchInput = root.querySelector('[data-pmg-variant-search]');
  var variantResultsEl = root.querySelector('[data-pmg-variant-results]');
  var selectedVariantEl = root.querySelector('[data-pmg-selected-variant]');
  var variantIdField = root.querySelector('[data-pmg-variant-id]');
  var variantSkuField = root.querySelector('[data-pmg-variant-sku]');
  var homeButton = root.querySelector('[data-pmg-home]');
  var lockedNote = root.querySelector('[data-pmg-locked-note]');
  var pdpImageInput = root.querySelector('[data-pmg-pdp-image-input]');
  var pdpImagePreview = root.querySelector('[data-pmg-pdp-image-preview]');
  var pdpImageRemoveButton = root.querySelector('[data-pmg-pdp-image-remove]');
  var pdpImageStatus = root.querySelector('[data-pmg-pdp-image-status]');
  var materialSearchInputs = root.querySelectorAll('[data-pmg-material-search]');
  var materialCategoryInputs = root.querySelectorAll('[data-pmg-material-category]');
  var materialUploadInputs = root.querySelectorAll('[data-pmg-material-upload]');
  var typePicker = root.querySelector('[data-pmg-type-picker]');
  var typePickButtons = root.querySelectorAll('[data-pmg-pick-type]');
  var builderPanel = root.querySelector('[data-pmg-builder]');
  var modeSections = root.querySelectorAll('[data-pmg-mode-section]');
  var viewButtons = root.querySelectorAll('[data-pmg-view-button]');
  var viewPanels = root.querySelectorAll('[data-pmg-view-panel]');
  var openCreateButtons = root.querySelectorAll('[data-pmg-open-create]');
  var createSteps = root.querySelectorAll('[data-pmg-create-step]');
  var stepIndicators = root.querySelectorAll('[data-pmg-step-indicator]');
  var stepTitles = root.querySelectorAll('[data-pmg-step-title]');
  var stepSubtitles = root.querySelectorAll('[data-pmg-step-subtitle]');
  var stepHeadings = root.querySelectorAll('[data-pmg-step-heading]');
  var stepCopies = root.querySelectorAll('[data-pmg-step-copy]');
  var prevStepButton = root.querySelector('[data-pmg-step-prev]');
  var nextStepButton = root.querySelector('[data-pmg-step-next]');
  var builderKicker = root.querySelector('[data-pmg-builder-kicker]');
  var builderTitle = root.querySelector('[data-pmg-builder-title]');
  var builderCopy = root.querySelector('[data-pmg-builder-copy]');
  var finishTitle = root.querySelector('[data-pmg-finish-title]');
  var finishCopy = root.querySelector('[data-pmg-finish-copy]');
  var saveLabel = root.querySelector('[data-pmg-save-label]');

  var selectedProducts = []; // [{handle, title, image}, ...]
  // The PDP banner and the top promo bar are separate things on the page, so
  // they get separate opt-ins rather than one lump of "content".
  var PRODUCT_BANNER_FIELDS = [
    ['pdp_discount_code', 'Discount code', 'text'],
    ['pdp_link', 'Banner link', 'url'],
  ];
  var PRODUCT_BAR_FIELDS = [
    ['pdp_bar_badge', 'Bar badge', 'text'],
    ['pdp_bar_text', 'Bar message', 'text'],
    ['pdp_bar_color', 'Bar colour', 'rgb'],
    ['pdp_bar_text_color', 'Text colour', 'text-color'],
  ];
  var PRODUCT_TEXT_OVERRIDES = PRODUCT_BANNER_FIELDS.concat(PRODUCT_BAR_FIELDS);
  // Per-product overrides stay collapsed until asked for: most campaigns run
  // one discount and one banner across every product, and showing a field per
  // product by default buried that common case.
  var productOverrides = { discount: false, banner: false, promobar: false };
  var productOverrideCollapsed = { discount: true, banner: true, promobar: true };
  // Set when a promotion is opened that can no longer be changed. Those still
  // open in the builder so the details can be read; the form is just locked.
  var readOnlyPromotion = null;
  var pendingApplyRefreshTimer = null;
  var pendingProductUploads = 0;
  var selectedVariant = null;
  var latestSearchResults = [];
  var latestVariantResults = [];
  var latestMaterialResults = {};
  var latestMaterialCategories = {};
  var currentPromotions = [];
  var currentPromotionFilter = 'current';
  var editingPromotion = null;
  var currentCreateStep = 0;
  var currentCreateType = 'product';

  var TOKEN_STORAGE_KEY = 'pmg_session_token';
  var PROMO_TIME_ZONE = 'Europe/Berlin';
  var MIN_PROMOTION_DURATION_MS = 2 * 60 * 1000;
  var MATERIAL_IMAGE_FIELDS = [
    'pdp_image',
    'homepage_desktop_image',
    'homepage_mobile_image',
    'sales_desktop_image',
    'sales_mobile_image',
  ];
  var HOMEPAGE_FIELDS = [
    'homepage_desktop_image',
    'homepage_mobile_image',
    'homepage_heading',
    'homepage_subheading',
    'homepage_button_1_label',
    'homepage_button_1_url',
    'homepage_button_2_label',
    'homepage_button_2_url',
    'pdp_bar_badge',
    'pdp_bar_text',
    'pdp_bar_color',
    'pdp_bar_text_color',
  ];
  var SALES_FIELDS = [
    'sales_desktop_image',
    'sales_mobile_image',
    'sales_heading',
    'sales_countdown_text',
  ];
  var PRODUCT_PROMO_FIELDS = [
    'variant_id',
    'variant_sku',
    'discount_percent',
    'price',
    'base_price',
    'after_discount_percent',
    'after_price',
    'pdp_image',
    'pdp_discount_code',
    'pdp_link',
    'pdp_bar_badge',
    'pdp_bar_text',
    'pdp_bar_color',
    'pdp_bar_text_color',
  ];
  var COMMON_PROMO_FIELDS = ['campaign', 'requested_by', 'start_at', 'end_at', 'notes'];
  var CLEARABLE_FIELDS = [
    'requested_by',
    'variant_id',
    'variant_sku',
    'discount_percent',
    'price',
    'base_price',
    'after_discount_percent',
    'after_price',
    'pdp_image',
    'homepage_desktop_image',
    'homepage_mobile_image',
    'homepage_heading',
    'homepage_subheading',
    'homepage_button_1_label',
    'homepage_button_1_url',
    'homepage_button_2_label',
    'homepage_button_2_url',
    'sales_desktop_image',
    'sales_mobile_image',
    'sales_heading',
    'sales_countdown_text',
    'pdp_discount_code',
    'pdp_link',
    'pdp_bar_badge',
    'pdp_bar_text',
    'pdp_bar_color',
    'pdp_bar_text_color',
    'notes',
  ];
  var TYPE_COPY = {
    product: {
      kicker: 'Product promotion',
      title: 'Create product promotion',
      copy: 'Schedule product pricing, PDP banners, and product-page promo bars.',
      basicsLegend: 'Product promotion',
      steps: [
        ['Products', 'Name and target'],
        ['Price', 'Discount and fallback'],
        ['Schedule', 'Start and end'],
        ['PDP', 'Banner and notes'],
      ],
      headings: [
        'Choose the campaign and products',
        'Set the price change',
        'Schedule the promotion',
        'Review product-page details',
      ],
      descriptions: [
        'Pick one or more products for price or PDP changes.',
        'Use either a discount percent or an exact sale price. Add an after-promo price only if something should stay active.',
        'Choose when the promotion should start and when the automatic rollback should run. Times are German time, shown as a 24-hour clock.',
        'Add PDP material or a product-page promo bar if needed.',
      ],
    },
    homepage: {
      kicker: 'Homepage content',
      title: 'Schedule homepage content',
      copy: 'Schedule homepage hero images and copy without attaching it to a product.',
      basicsLegend: 'Homepage schedule',
      steps: [
        ['Basics', 'Campaign name'],
        ['Homepage', 'Images and text'],
        ['Schedule', 'Start and end'],
        ['Finish', 'Notes'],
      ],
      headings: [
        'Name this homepage schedule',
        'Set homepage hero content',
        'Schedule the homepage change',
        'Review homepage schedule',
      ],
      descriptions: [
        'This is separate from product promotions and does not need a product target.',
        'Choose uploaded hero images and text. Empty fields keep the current homepage default.',
        'Choose when the homepage content should start and when it should revert. Times are German time, shown as a 24-hour clock.',
        'Save the draft, then publish it from the promotions list when ready.',
      ],
    },
    sales: {
      kicker: 'Sales page content',
      title: 'Schedule sales page content',
      copy: 'Schedule sales page hero images and copy without attaching it to a product.',
      basicsLegend: 'Sales page schedule',
      steps: [
        ['Basics', 'Campaign name'],
        ['Sales page', 'Images and text'],
        ['Schedule', 'Start and end'],
        ['Finish', 'Notes'],
      ],
      headings: [
        'Name this sales page schedule',
        'Set sales page hero content',
        'Schedule the sales page change',
        'Review sales page schedule',
      ],
      descriptions: [
        'This is separate from product promotions and does not need a product target.',
        'Choose uploaded hero images and offer-page text. Empty fields keep the current sales page default.',
        'Choose when the sales page content should start and when it should revert. Times are German time, shown as a 24-hour clock.',
        'Save the draft, then publish it from the promotions list when ready.',
      ],
    },
  };

  function api(path, options) {
    options = options || {};
    var headers = Object.assign({}, options.headers);
    var token = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (token) headers.Authorization = 'Bearer ' + token;
    return fetch(workerUrl + path, Object.assign({}, options, { headers: headers }))
      .catch(function (error) {
        if (workerUrl === 'http://127.0.0.1:8790') {
          throw new Error('Local login connection unavailable. Start npm run promo:preview-proxy, then try again.');
        }
        throw error;
      })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) {
            var message = body && body.error ? body.error : 'Request failed (' + response.status + ')';
            if (body && Array.isArray(body.details) && body.details.length) {
              message += ': ' + body.details.map(function (detail) {
                if (typeof detail === 'string') return detail;
                if (detail && detail.message) {
                  var field = Array.isArray(detail.field) ? detail.field.join('.') : detail.field;
                  return (field ? field + ': ' : '') + detail.message;
                }
                try { return JSON.stringify(detail); } catch (error) { return String(detail); }
              }).join('; ');
            }
            throw new Error(message);
          }
          return body;
        });
      });
  }

  function showError(target, message) {
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function clearError(target) {
    if (!target) return;
    target.hidden = true;
    target.textContent = '';
  }

  function scrollWorkspaceIntoView() {
    if (!contentView || contentView.hidden) return;
    window.requestAnimationFrame(function () {
      var navHeight = root.querySelector('.pmg__top-nav') ? root.querySelector('.pmg__top-nav').offsetHeight : 68;
      var top = contentView.getBoundingClientRect().top + window.pageYOffset - navHeight - 18;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    });
  }

  function setAppView(view, refresh) {
    Array.prototype.forEach.call(viewPanels, function (panel) {
      panel.hidden = panel.getAttribute('data-pmg-view-panel') !== view;
    });
    Array.prototype.forEach.call(viewButtons, function (button) {
      var isActive = button.getAttribute('data-pmg-view-button') === view;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    root.setAttribute('data-pmg-current-view', view);
    if (view === 'create') setCreateStep(currentCreateStep);
    if (view === 'promotions' && refresh) loadPromotions();
    scrollWorkspaceIntoView();
  }

  function setCreateStep(index, keepScroll) {
    var maxIndex = Math.max(createSteps.length - 1, 0);
    currentCreateStep = Math.max(0, Math.min(index, maxIndex));

    Array.prototype.forEach.call(createSteps, function (step, stepIndex) {
      step.hidden = stepIndex !== currentCreateStep;
    });
    Array.prototype.forEach.call(stepIndicators, function (indicator, stepIndex) {
      indicator.classList.toggle('is-active', stepIndex === currentCreateStep);
      indicator.classList.toggle('is-complete', stepIndex < currentCreateStep);
      indicator.setAttribute('aria-current', stepIndex === currentCreateStep ? 'step' : 'false');
    });

    // A new promotion uses the first step's Back button to return to the type
    // picker. Saved promotions have no type picker to return to.
    if (prevStepButton) prevStepButton.disabled = currentCreateStep === 0 && Boolean(editingPromotion);
    if (nextStepButton) nextStepButton.hidden = currentCreateStep === maxIndex;
    if (createSubmitButton) createSubmitButton.hidden = Boolean(readOnlyPromotion);
    clearError(createError);
    if (!keepScroll) scrollWorkspaceIntoView();
  }

  function formField(name) {
    return createForm.elements[name];
  }

  function fieldHasValue(name) {
    var field = formField(name);
    return Boolean(field && String(field.value || '').trim() !== '');
  }

  function hasPriceRule() {
    return fieldHasValue('discount_percent') || fieldHasValue('price');
  }

  function hasPdpContent() {
    return ['pdp_image', 'pdp_discount_code', 'pdp_link', 'pdp_bar_badge', 'pdp_bar_text'].some(fieldHasValue);
  }

  function hasPageContent() {
    return [
      'homepage_desktop_image',
      'homepage_mobile_image',
      'homepage_heading',
      'homepage_subheading',
      'homepage_button_1_label',
      'homepage_button_1_url',
      'homepage_button_2_label',
      'homepage_button_2_url',
      'sales_desktop_image',
      'sales_mobile_image',
      'sales_heading',
      'sales_countdown_text',
    ].some(fieldHasValue);
  }

  function validateCreateStep(index) {
    clearError(createError);

    if (index === 0) {
      var campaign = formField('campaign');
      if (campaign && !campaign.checkValidity()) {
        campaign.reportValidity();
        return false;
      }
    }

    if (index === 1) {
      if (currentCreateType === 'product') {
        var priceFields = ['discount_percent', 'price', 'base_price', 'after_discount_percent', 'after_price'];
        for (var priceFieldIndex = 0; priceFieldIndex < priceFields.length; priceFieldIndex += 1) {
          var priceField = formField(priceFields[priceFieldIndex]);
          if (priceField && String(priceField.value || '').trim() !== '' && !priceField.checkValidity()) {
            priceField.reportValidity();
            return false;
          }
        }
      }
    }

    if (index === 2) {
      var startAt = formField('start_at');
      var endAt = formField('end_at');
      if (startAt && !startAt.checkValidity()) {
        startAt.reportValidity();
        return false;
      }
      if (endAt && !endAt.checkValidity()) {
        endAt.reportValidity();
        return false;
      }
      var startDate = startAt && zonedDateTimeLocalToDate(startAt.value, PROMO_TIME_ZONE);
      var endDate = endAt && zonedDateTimeLocalToDate(endAt.value, PROMO_TIME_ZONE);
      if (startAt && endAt && startAt.value && endAt.value && startDate && endDate && endDate.getTime() <= startDate.getTime()) {
        showError(createError, 'End time must be after the start time.');
        endAt.focus();
        return false;
      }
      if (startAt && endAt && startDate && endDate && endDate.getTime() - startDate.getTime() < MIN_PROMOTION_DURATION_MS) {
        showError(createError, 'Promotion duration must be at least 2 minutes because the live scheduler checks every minute.');
        endAt.focus();
        return false;
      }
    }

    return true;
  }

  function validateCreateFlow() {
    for (var stepIndex = 0; stepIndex < createSteps.length - 1; stepIndex += 1) {
      if (!validateCreateStep(stepIndex)) {
        setCreateStep(stepIndex);
        return false;
      }
    }
    return true;
  }

  function setText(target, value) {
    if (target) target.textContent = value;
  }

  function copyForCurrentType() {
    return TYPE_COPY[currentCreateType] || TYPE_COPY.product;
  }

  function setNodeTextByIndex(nodes, index, value) {
    Array.prototype.forEach.call(nodes, function (node) {
      var nodeIndex = node.getAttribute('data-pmg-step-title') ||
        node.getAttribute('data-pmg-step-subtitle') ||
        node.getAttribute('data-pmg-step-heading') ||
        node.getAttribute('data-pmg-step-copy');
      if (Number(nodeIndex) === index) {
        node.textContent = value;
      }
    });
  }

  function setStepCopyForType() {
    var copy = copyForCurrentType();
    copy.steps.forEach(function (step, index) {
      setNodeTextByIndex(stepTitles, index, step[0]);
      setNodeTextByIndex(stepSubtitles, index, step[1]);
      setNodeTextByIndex(stepHeadings, index, copy.headings[index]);
      setNodeTextByIndex(stepCopies, index, copy.descriptions[index]);
    });
    var basicsLegend = root.querySelector('[data-pmg-basics-legend]');
    if (basicsLegend) basicsLegend.textContent = copy.basicsLegend;
  }

  function setCreateType(type, keepScroll) {
    currentCreateType = TYPE_COPY[type] ? type : 'product';
    createForm.setAttribute('data-pmg-current-type', currentCreateType);
    Array.prototype.forEach.call(modeSections, function (section) {
      section.hidden = section.getAttribute('data-pmg-mode-section') !== currentCreateType;
    });
    if (variantPicker) variantPicker.hidden = currentCreateType !== 'product' || selectedProducts.length !== 1;
    setStepCopyForType();
    setBuilderMode(editingPromotion ? 'edit' : 'create');
    renderSelectedProducts();
    renderSelectedVariant();
    setCreateStep(Math.min(currentCreateStep, createSteps.length - 1), keepScroll);
  }

  // A new promotion starts by choosing its type, and the builder then only
  // shows that type. Saving a promotion in another type rewrites the fields
  // that type owns (a homepage save replaced a product promotion's products),
  // so the builder never switches type: a new promotion can only go back to
  // the picker by discarding everything entered, and a saved one cannot.
  function showTypePicker(show) {
    if (typePicker) typePicker.hidden = !show;
    if (builderPanel) builderPanel.hidden = show;
  }

  function modeFromPromotion(promotion) {
    if (!promotion) return 'product';
    var savedTargets = promotion.product_targets;
    if (typeof savedTargets === 'string') {
      try { savedTargets = JSON.parse(savedTargets); } catch (error) { savedTargets = []; }
    }
    if (savedTargets && !Array.isArray(savedTargets) && savedTargets.promotion_type === 'sales') return 'sales';
    if (savedTargets && !Array.isArray(savedTargets) && savedTargets.promotion_type === 'homepage') return 'homepage';
    var hasProductTargets = Array.isArray(savedTargets) && savedTargets.length > 0;
    var hasProduct = Boolean(promotion.product_handle || hasProductTargets || promotion.variant_id || promotion.variant_sku);
    var hasProductPromo = hasProduct || PRODUCT_PROMO_FIELDS.some(function (key) {
      if (/^pdp_bar_/.test(key)) return false;
      return String(promotion[key] || '').trim() !== '';
    });
    if (hasProductPromo) return 'product';
    if (SALES_FIELDS.some(function (key) { return String(promotion[key] || '').trim() !== ''; })) return 'sales';
    if (HOMEPAGE_FIELDS.some(function (key) { return String(promotion[key] || '').trim() !== ''; })) return 'homepage';
    return 'product';
  }

  function setBuilderMode(mode) {
    var isEditing = mode === 'edit';
    var isLocked = Boolean(readOnlyPromotion);
    var isScheduledEdit = !isLocked && editingPromotion && editingPromotion.status === 'approved';
    var isLiveEdit = !isLocked && editingPromotion && editingPromotion.status === 'active';
    var copy = copyForCurrentType();
    setText(builderKicker, isLocked ? 'View ' + copy.kicker.toLowerCase() : isEditing ? 'Edit ' + copy.kicker.toLowerCase() : copy.kicker);
    setText(
      builderTitle,
      isLocked
        ? 'View ' + copy.kicker.toLowerCase()
        : isScheduledEdit
          ? 'Edit scheduled ' + copy.kicker.toLowerCase()
          : isEditing
            ? 'Edit ' + copy.kicker.toLowerCase()
            : copy.title
    );
    setText(
      builderCopy,
      isLocked
        ? 'These details are read-only. Step through to review them.'
        : isLiveEdit
          ? 'Edit this live promotion. Publishing applies the content changes immediately without changing its products, pricing, or dates.'
        : isScheduledEdit
          ? 'Update this scheduled item before it starts. Active and ended items stay locked.'
          : isEditing
            ? 'Update this draft. You can save it again without scheduling.'
            : copy.copy
    );
    setText(
      finishTitle,
      isLocked ? 'Review details' : isLiveEdit ? 'Review and publish changes' : isScheduledEdit ? 'Review and update schedule' : isEditing ? 'Review and update draft' : 'Review and save as draft'
    );
    setText(
      finishCopy,
      isLocked
        ? readOnlyMessageFor(readOnlyPromotion)
        : isLiveEdit
          ? 'Review the edited promotional content, then publish it to the live storefront immediately.'
        : isScheduledEdit
          ? 'Review the details, then update this scheduled promotion before it starts.'
          : isEditing
            ? 'Review the details, then update this draft. Publish it from the list when ready.'
            : copy.descriptions[3]
    );
    setText(saveLabel, isLiveEdit ? 'Publish changes immediately' : isScheduledEdit ? 'Update schedule' : isEditing ? 'Update draft' : 'Save draft');
  }

  function getTimeZoneParts(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    });
    var parts = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') parts[part.type] = part.value;
    });
    return parts;
  }

  function getTimeZoneOffsetMs(date, timeZone) {
    var parts = getTimeZoneParts(date, timeZone);
    var asUtc = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );
    return asUtc - date.getTime();
  }

  function zonedDateTimeLocalToDate(value, timeZone) {
    if (!value) return null;
    var match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (!match) return null;
    var localUtc = Date.UTC(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4]),
      Number(match[5]),
      0
    );
    var utcMs = localUtc;
    for (var attempt = 0; attempt < 3; attempt += 1) {
      utcMs = localUtc - getTimeZoneOffsetMs(new Date(utcMs), timeZone);
    }
    var date = new Date(utcMs);
    return isNaN(date.getTime()) ? null : date;
  }

  function zonedDateTimeLocalToIso(value, timeZone) {
    var date = zonedDateTimeLocalToDate(value, timeZone);
    return date ? date.toISOString() : value;
  }

  function toDateTimeLocal(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    var parts = getTimeZoneParts(date, PROMO_TIME_ZONE);
    return parts.year + '-' + parts.month + '-' + parts.day + 'T' + parts.hour + ':' + parts.minute;
  }

  function fieldValue(name, value) {
    var field = formField(name);
    if (field) field.value = value || '';
  }

  function materialInput(field) {
    return root.querySelector('[data-pmg-material-input="' + field + '"]');
  }

  function materialSelectedEl(field) {
    return root.querySelector('[data-pmg-material-selected="' + field + '"]');
  }

  function materialResultsEl(field) {
    return root.querySelector('[data-pmg-material-results="' + field + '"]');
  }

  function materialSearchInput(field) {
    return root.querySelector('[data-pmg-material-search="' + field + '"]');
  }

  function materialCategoryInput(field) {
    return root.querySelector('[data-pmg-material-category="' + field + '"]');
  }

  function materialCategory(field) {
    var input = materialCategoryInput(field);
    return input ? input.value || 'all' : 'all';
  }

  function materialTitle(material) {
    if (!material) return '';
    return material.title || material.alt || material.filename || material.id || 'Selected material';
  }

  function setMaterialField(field, material, statusText) {
    var input = materialInput(field);
    var selectedEl = materialSelectedEl(field);
    var title = materialTitle(material);
    if (input) input.value = material && material.id ? material.id : '';
    if (selectedEl) {
      selectedEl.innerHTML = material && material.id
        ? '<span class="pmg__material-chip">' +
            (material.previewUrl ? '<img src="' + escapeHtml(material.previewUrl) + '" alt="">' : '<span class="pmg__chip-noimg"></span>') +
            '<span>' + escapeHtml(title) + '</span>' +
            '<button type="button" data-pmg-clear-material="' + escapeHtml(field) + '" aria-label="Clear ' + escapeHtml(title) + '">&times;</button>' +
          '</span>'
        : '';
    }
    if (field === 'pdp_image') {
      if (material && material.previewUrl) {
        showPdpImagePreview(material.previewUrl, statusText || 'Selected existing material');
      } else if (material && pdpImageStatus) {
        pdpImagePreview.hidden = true;
        pdpImageStatus.textContent = statusText || 'Image selected, preview unavailable';
      }
    }
  }

  function resetMaterials() {
    MATERIAL_IMAGE_FIELDS.forEach(function (field) {
      setMaterialField(field, null);
      var searchInput = materialSearchInput(field);
      var resultsEl = materialResultsEl(field);
      if (searchInput) searchInput.value = '';
      if (resultsEl) resultsEl.hidden = true;
      latestMaterialResults[field] = [];
      latestMaterialCategories[field] = '';
      var uploadStatus = root.querySelector('[data-pmg-material-upload-status="' + field + '"]');
      var uploadInput = root.querySelector('[data-pmg-material-upload="' + field + '"]');
      if (uploadStatus) uploadStatus.textContent = '';
      if (uploadInput) uploadInput.value = '';
    });
  }

  function resetCreateForm() {
    editingPromotion = null;
    readOnlyPromotion = null;
    applyReadOnlyState();
    createForm.reset();
    syncSharedRgbControl();
    resetProductOverrideToggles();
    selectedProducts = [];
    selectedVariant = null;
    currentCreateStep = 0;
    renderSelectedProducts();
    renderSelectedVariant();
    resetMaterials();
    resetPdpImage();
    setCreateType('product', true);
    setCreateStep(0);
    showTypePicker(true);
  }

  function selectedProductFromPromotion(promotion) {
    var handle = promotion.product_handle || '';
    if (!handle && !promotion.variant_id) return null;
    var target = handle || promotion.variant_id || 'Promotion target';
    return {
      handle: handle,
      variant_id: promotion.variant_id || '',
      title: target,
      image: null,
    };
  }

  // Every target stores a copy of the shared bar colours, because the promotion
  // metaobject has no top-level colour fields. A copy that still equals the
  // saved shared colour is inherited, not a per-product choice, so it must not
  // pin the product to the old colour when the shared colour is edited.
  function overridesFromTarget(target) {
    var overrides = Object.assign({}, target);
    [['pdp_bar_color', 'shared_pdp_bar_color'], ['pdp_bar_text_color', 'shared_pdp_bar_text_color']].forEach(function (pair) {
      var own = String(overrides[pair[0]] || '').toLowerCase();
      var shared = String(overrides[pair[1]] || '').toLowerCase();
      if (own && shared && own === shared) delete overrides[pair[0]];
    });
    return overrides;
  }

  function productsFromPromotion(promotion) {
    var targets = promotion && promotion.product_targets;
    if (typeof targets === 'string') {
      try { targets = JSON.parse(targets); } catch (error) { targets = []; }
    }
    if (Array.isArray(targets) && targets.length) {
      return targets.map(function (target) {
        return {
          handle: target.product_handle || '',
          title: target.title || target.product_handle || 'Product',
          discountOverride: target.discount_percent,
          imageOverride: target.pdp_image ? {
            id: target.pdp_image,
            title: target.pdp_image_title || 'Saved Shopify image',
            previewUrl: target.pdp_image_preview_url || null,
          } : null,
          textOverrides: overridesFromTarget(target),
        };
      });
    }
    var product = selectedProductFromPromotion(promotion);
    return product ? [product] : [];
  }

  function selectedVariantFromPromotion(promotion) {
    if (!promotion.variant_id && !promotion.variant_sku) return null;
    return {
      id: promotion.variant_id || '',
      sku: promotion.variant_sku || '',
      title: promotion.variant_sku || promotion.variant_id || 'Selected variant',
    };
  }

  function editPromotion(promotion) {
    if (!promotion) return;
    editingPromotion = promotion;
    readOnlyPromotion = promotionIsEditable(promotion) ? null : promotion;
    createForm.reset();
    resetProductOverrideToggles();
    resetMaterials();
    resetPdpImage();
    setCreateType(modeFromPromotion(promotion), true);
    fieldValue('campaign', promotion.campaign);
    fieldValue('requested_by', promotion.requested_by);
    fieldValue('variant_id', promotion.variant_id);
    fieldValue('variant_sku', promotion.variant_sku);
    fieldValue('discount_percent', promotion.discount_percent);
    fieldValue('price', promotion.price);
    fieldValue('base_price', promotion.base_price);
    fieldValue('start_at', toDateTimeLocal(promotion.start_at));
    fieldValue('end_at', toDateTimeLocal(promotion.end_at));
    fieldValue('after_discount_percent', promotion.after_discount_percent);
    fieldValue('after_price', promotion.after_price);
    fieldValue('pdp_discount_code', promotion.pdp_discount_code);
    fieldValue('pdp_link', promotion.pdp_link);
    fieldValue('homepage_heading', promotion.homepage_heading);
    fieldValue('homepage_subheading', promotion.homepage_subheading);
    fieldValue('homepage_button_1_label', promotion.homepage_button_1_label);
    fieldValue('homepage_button_1_url', promotion.homepage_button_1_url);
    fieldValue('homepage_button_2_label', promotion.homepage_button_2_label);
    fieldValue('homepage_button_2_url', promotion.homepage_button_2_url);
    fieldValue('sales_heading', promotion.sales_heading);
    fieldValue('sales_countdown_text', promotion.sales_countdown_text);
    fieldValue('pdp_bar_badge', promotion.pdp_bar_badge);
    fieldValue('pdp_bar_text', promotion.pdp_bar_text);
    fieldValue('homepage_ui_bar_badge', promotion.pdp_bar_badge);
    fieldValue('homepage_ui_bar_text', promotion.pdp_bar_text);
    var savedTargets = promotion.product_targets;
    if (typeof savedTargets === 'string') {
      try { savedTargets = JSON.parse(savedTargets); } catch (error) { savedTargets = []; }
    }
    // Homepage promotions keep their bar colours in the same options object as
    // the text alignment, because the metaobject has no colour fields.
    var homepageOptions = savedTargets && !Array.isArray(savedTargets) ? savedTargets : {};
    fieldValue('homepage_ui_bar_color', promotion.pdp_bar_color || homepageOptions.pdp_bar_color || '#7a932b');
    fieldValue('homepage_ui_bar_text_color', promotion.pdp_bar_text_color || homepageOptions.pdp_bar_text_color || '#ffffff');
    fieldValue('homepage_text_alignment', homepageOptions.homepage_text_alignment === 'right' ? 'right' : 'left');
    fieldValue('sales_ui_bar_badge', promotion.pdp_bar_badge);
    fieldValue('sales_ui_bar_text', promotion.pdp_bar_text);
    fieldValue('sales_ui_bar_color', promotion.pdp_bar_color || homepageOptions.pdp_bar_color || '#7a932b');
    fieldValue('sales_ui_bar_text_color', promotion.pdp_bar_text_color || homepageOptions.pdp_bar_text_color || '#ffffff');
    var firstTargetColor = Array.isArray(savedTargets) && savedTargets.length
      ? (savedTargets[0].shared_pdp_bar_color || savedTargets[0].pdp_bar_color)
      : '';
    fieldValue('pdp_bar_color', promotion.pdp_bar_color || firstTargetColor || '#7a932b');
    var firstTargetTextColor = Array.isArray(savedTargets) && savedTargets.length
      ? (savedTargets[0].shared_pdp_bar_text_color || savedTargets[0].pdp_bar_text_color)
      : '';
    fieldValue('pdp_bar_text_color', promotion.pdp_bar_text_color || firstTargetTextColor || '#000000');
    syncSharedRgbControl();
    fieldValue('notes', promotion.notes);
    selectedProducts = productsFromPromotion(promotion);
    productOverrides.discount = selectedProducts.some(function (product) {
      return product.discountOverride !== undefined && product.discountOverride !== '';
    });
    productOverrides.banner = selectedProducts.some(function (product) {
      return Boolean(product.imageOverride) || PRODUCT_BANNER_FIELDS.some(function (field) {
        return Boolean(product.textOverrides && product.textOverrides[field[0]]);
      });
    });
    productOverrides.promobar = selectedProducts.some(function (product) {
      var overrides = product.textOverrides || {};
      if (overrides.pdp_bar_badge || overrides.pdp_bar_text) return true;
      var barColor = String(overrides.pdp_bar_color || '').toLowerCase();
      var sharedBarColor = String(overrides.shared_pdp_bar_color || '').toLowerCase();
      var textColor = String(overrides.pdp_bar_text_color || '').toLowerCase();
      var sharedTextColor = String(overrides.shared_pdp_bar_text_color || '').toLowerCase();
      // Shared colours must live on every target because the promotion
      // metaobject has no spare top-level fields. Only treat a colour as a
      // per-product override when it differs from its saved shared value.
      return Boolean(
        (barColor && (!sharedBarColor || barColor !== sharedBarColor)) ||
        (textColor && (!sharedTextColor || textColor !== sharedTextColor))
      );
    });
    root.querySelectorAll('[data-pmg-override-toggle]').forEach(function (toggle) {
      toggle.checked = Boolean(productOverrides[toggle.getAttribute('data-pmg-override-toggle')]);
    });
    selectedVariant = selectedVariantFromPromotion(promotion);
    MATERIAL_IMAGE_FIELDS.forEach(function (field) {
      if (!promotion[field]) return;
      setMaterialField(field, {
        id: promotion[field],
        title: field.replace(/_/g, ' '),
        previewUrl: promotion[field + '_preview_url'] || null,
      }, 'Image selected');
    });
    renderSelectedProducts();
    renderSelectedVariant();
    setBuilderMode('edit');
    setCreateStep(0);
    applyReadOnlyState();
    showTypePicker(false);
    setAppView('create', false);
  }

  function showLoggedIn(skipRefresh) {
    loginView.hidden = true;
    contentView.hidden = false;
    if (homeButton) homeButton.disabled = false;
    setAppView('promotions', !skipRefresh);
  }

  function showLoggedOut() {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    loginView.hidden = false;
    contentView.hidden = true;
    if (homeButton) homeButton.disabled = true;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDiscount(promotion) {
    var targets = promotion.product_targets;
    if (typeof targets === 'string') {
      try { targets = JSON.parse(targets); } catch (error) { targets = []; }
    }
    if (Array.isArray(targets) && targets.length > 1) return targets.length + ' product rules';
    if (promotion.discount_percent) return promotion.discount_percent + '%';
    if (promotion.price) return String(promotion.price);
    if (HOMEPAGE_FIELDS.concat(SALES_FIELDS).some(function (key) { return String(promotion[key] || '').trim() !== ''; })) return 'Content';
    return '-';
  }

  function formatTarget(promotion) {
    var placementLabels = [];
    if (HOMEPAGE_FIELDS.some(function (key) { return String(promotion[key] || '').trim() !== ''; })) placementLabels.push('Homepage');
    if (SALES_FIELDS.some(function (key) { return String(promotion[key] || '').trim() !== ''; })) placementLabels.push('Sales page');
    var targets = promotion.product_targets;
    if (typeof targets === 'string') {
      try { targets = JSON.parse(targets); } catch (error) { targets = []; }
    }
    if (Array.isArray(targets) && targets.length) {
      return targets.map(function (target) { return target.title || target.product_handle; }).join(', ');
    }
    if (!promotion.product_handle && !promotion.variant_id && placementLabels.length) return placementLabels.join(' + ');
    var target = promotion.product_handle || promotion.variant_id || '-';
    if (promotion.variant_sku) target += ' (' + promotion.variant_sku + ')';
    else if (promotion.variant_id) target += ' (variant ID)';
    return target;
  }

  function formatDate(value) {
    if (!value) return '-';
    var date = new Date(value);
    if (isNaN(date.getTime())) return value;
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: PROMO_TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZoneName: 'short',
    }).format(date);
  }

  function promotionIsEditable(promotion) {
    return Boolean(promotion) && (
      promotion.status === 'draft' ||
      promotion.status === 'active' ||
      isScheduledUpcoming(promotion)
    );
  }

  function readOnlyMessageFor(promotion) {
    if (!promotion) return '';
    if (promotion.status === 'approved') {
      return 'This promotion has already started. Choose "Cancel" in the list to stop it before making changes.';
    }
    if (promotion.status === 'error') {
      return 'This promotion could not be applied' +
        (promotion.error_message ? ': ' + promotion.error_message : '') +
        '. Create a new one to try again.';
    }
    if (promotion.status === 'rolled_back') {
      return 'This promotion was cancelled and can no longer be changed. Create a new one to run it again.';
    }
    return 'This promotion has ended and can no longer be changed. Create a new one to run it again.';
  }

  function applyReadOnlyState() {
    var locked = Boolean(readOnlyPromotion);
    createForm.classList.toggle('pmg__form--locked', locked);
    Array.prototype.forEach.call(createForm.querySelectorAll('input, select, textarea, button'), function (control) {
      // Step navigation and the save button are owned by setCreateStep, and
      // paging through the steps is the whole point of opening a locked item.
      if (control === prevStepButton || control === nextStepButton || control === createSubmitButton) return;
      control.disabled = locked;
    });
    if (createSubmitButton) createSubmitButton.hidden = locked;
    if (lockedNote) {
      lockedNote.hidden = !locked;
      lockedNote.textContent = locked ? readOnlyMessageFor(readOnlyPromotion) : '';
    }
  }

  function isScheduledUpcoming(promotion) {
    return promotion && promotion.status === 'approved' && promotion.start_at && new Date(promotion.start_at).getTime() > Date.now();
  }

  function formatCampaignCell(promotion) {
    var bits = [];
    if (promotion.requested_by) bits.push('Requested by ' + promotion.requested_by);
    if (promotion.status !== 'draft' && promotion.approved_at) bits.push('Scheduled ' + formatDate(promotion.approved_at));
    if (promotion.error_message) bits.push('Error: ' + promotion.error_message);
    return '<strong class="pmg__campaign-title">' + escapeHtml(promotion.campaign || 'Promotion') + '</strong>' +
      (bits.length ? '<span class="pmg__table-meta">' + escapeHtml(bits.join(' · ')) + '</span>' : '');
  }

  var DELETABLE_STATUSES = { draft: true, ended: true, rolled_back: true, error: true };

  function actionsForPromotion(promotion) {
    var actions = [];
    if (promotion.status === 'draft') {
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--edit" data-pmg-edit-promotion="' + escapeHtml(promotion.id) + '">Edit</button>');
      actions.push('<button type="button" class="pmg__action-btn" data-pmg-approve="' + escapeHtml(promotion.id) + '">Publish</button>');
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-cancel="' + escapeHtml(promotion.id) + '">Cancel</button>');
    } else if (promotion.status === 'approved') {
      if (isScheduledUpcoming(promotion)) {
        actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--edit" data-pmg-edit-promotion="' + escapeHtml(promotion.id) + '">Edit</button>');
        actions.push('<button type="button" class="pmg__action-btn" data-pmg-pause="' + escapeHtml(promotion.id) + '">Back to draft</button>');
        actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-cancel="' + escapeHtml(promotion.id) + '">Cancel</button>');
      } else {
        actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-cancel="' + escapeHtml(promotion.id) + '">Cancel</button>');
        actions.push('<span>Applying changes…</span>');
      }
    } else if (promotion.status === 'active') {
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--edit" data-pmg-edit-promotion="' + escapeHtml(promotion.id) + '">Edit</button>');
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-cancel="' + escapeHtml(promotion.id) + '">End now</button>');
    }
    if (DELETABLE_STATUSES[promotion.status]) {
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-delete="' + escapeHtml(promotion.id) + '">Delete</button>');
    }
    return '<div class="pmg__row-actions">' + actions.join('') + '</div>';
  }

  var STATUS_LABELS = { draft: 'Draft', approved: 'Scheduled', active: 'Active', ended: 'Ended', rolled_back: 'Cancelled', error: 'Error' };
  var STATUS_ORDER = { draft: 0, approved: 1, active: 2, error: 3, ended: 4, rolled_back: 5 };
  var PROMOTION_FILTER_STATUSES = {
    current: { draft: true, approved: true, active: true, error: true },
    active: { active: true },
    'active-drafts': { active: true, draft: true },
    draft: { draft: true },
    approved: { approved: true },
    ended: { ended: true },
    rolled_back: { rolled_back: true },
  };

  function promotionsForCurrentFilter(promotions) {
    if (currentPromotionFilter === 'all') return promotions.slice();
    var allowed = PROMOTION_FILTER_STATUSES[currentPromotionFilter] || PROMOTION_FILTER_STATUSES.current;
    return promotions.filter(function (promotion) { return Boolean(allowed[promotion.status || 'draft']); });
  }

  function renderSummary(promotions) {
    var counts = {};
    promotions.forEach(function (promotion) {
      var status = promotion.status || 'draft';
      counts[status] = (counts[status] || 0) + 1;
    });
    var parts = Object.keys(STATUS_LABELS)
      .filter(function (status) { return counts[status]; })
      .map(function (status) {
        return '<span class="pmg__summary-item pmg__status--' + status + '">' + counts[status] + ' ' + STATUS_LABELS[status].toLowerCase() + '</span>';
      });
    summaryEl.innerHTML = parts.length ? parts.join('') : '<span class="pmg__summary-item">No promotions yet</span>';
  }

  function renderPromotions(promotions) {
    currentPromotions = promotions || [];
    if (pendingApplyRefreshTimer) {
      window.clearTimeout(pendingApplyRefreshTimer);
      pendingApplyRefreshTimer = null;
    }
    renderSummary(promotions);

    if (!promotions.length) {
      rowsBody.innerHTML = '<tr><td colspan="7" class="pmg__empty">No promotions yet.</td></tr>';
      return;
    }

    var visiblePromotions = promotionsForCurrentFilter(promotions);
    var sorted = visiblePromotions.sort(function (a, b) {
      var orderA = STATUS_ORDER[a.status] != null ? STATUS_ORDER[a.status] : 99;
      var orderB = STATUS_ORDER[b.status] != null ? STATUS_ORDER[b.status] : 99;
      if (orderA !== orderB) return orderA - orderB;
      return (a.start_at || '').localeCompare(b.start_at || '');
    });

    rowsBody.innerHTML = sorted.length ? sorted.map(function (promotion) {
      // Every row opens. Ones that can no longer be changed open locked, which
      // beats a row that silently does nothing when clicked.
      var canEdit = promotionIsEditable(promotion);
      var rowClass = canEdit ? 'pmg__row--editable' : 'pmg__row--editable pmg__row--locked';
      return '<tr class="' + rowClass + '" data-pmg-edit-promotion="' + escapeHtml(promotion.id) +
        '" tabindex="0" aria-label="' + (canEdit ? 'Edit ' : 'View ') + escapeHtml(promotion.campaign || 'promotion') + '">' +
        '<td><span class="pmg__status pmg__status--' + escapeHtml(promotion.status || 'draft') + '">' + escapeHtml(STATUS_LABELS[promotion.status] || promotion.status || 'draft') + '</span></td>' +
        '<td>' + formatCampaignCell(promotion) + '</td>' +
        '<td><span class="pmg__target-preview">' + escapeHtml(formatTarget(promotion)) + '</span></td>' +
        '<td>' + escapeHtml(formatDiscount(promotion)) + '</td>' +
        '<td>' + escapeHtml(formatDate(promotion.start_at)) + '</td>' +
        '<td>' + escapeHtml(formatDate(promotion.end_at)) + '</td>' +
        '<td>' + actionsForPromotion(promotion) + '</td>' +
        '</tr>';
    }).join('') : '<tr><td colspan="7" class="pmg__empty">No promotions match this filter.</td></tr>';

    var hasPendingApply = promotions.some(function (promotion) {
      return promotion.status === 'approved' && !isScheduledUpcoming(promotion);
    });
    if (hasPendingApply) {
      pendingApplyRefreshTimer = window.setTimeout(loadPromotions, 10000);
    }
  }

  function loadPromotions() {
    rowsBody.innerHTML = '<tr><td colspan="7" class="pmg__empty">Loading...</td></tr>';
    api('/promotions')
      .then(function (data) {
        renderPromotions(data.promotions || []);
      })
      .catch(function (error) {
        if (/not authenticated|session expired/i.test(error.message)) {
          showLoggedOut();
          return;
        }
        rowsBody.innerHTML = '<tr><td colspan="7" class="pmg__empty">' + escapeHtml(error.message) + '</td></tr>';
      });
  }

  // ---------------------------------------------------------------------
  // Product picker (search + multi-select)
  // ---------------------------------------------------------------------

  function overrideTextFields(product, fields) {
    return fields.map(function (field) {
      var value = product.textOverrides && product.textOverrides[field[0]] || '';
      if (field[2] === 'rgb') {
        value = value || (formField(field[0]) ? formField(field[0]).value : '#7a932b');
        return rgbControlHtml(value, field[0]);
      }
      if (field[2] === 'text-color') {
        value = value || (formField(field[0]) ? formField(field[0]).value : '#000000');
        return '<label><span>' + field[1] + '</span><select data-pmg-product-text="' + field[0] + '">' +
          '<option value="#000000"' + (value.toLowerCase() === '#000000' ? ' selected' : '') + '>Black</option>' +
          '<option value="#ffffff"' + (value.toLowerCase() === '#ffffff' ? ' selected' : '') + '>White</option></select></label>';
      }
      return '<label><span>' + field[1] + '</span><input type="' + field[2] +
        '" data-pmg-product-text="' + field[0] + '" value="' + escapeHtml(value) +
        '" placeholder="Use shared value"></label>';
    }).join('');
  }

  function clampRgb(value) {
    var number = Number(value);
    return Math.max(0, Math.min(255, Number.isFinite(number) ? Math.round(number) : 0));
  }

  function hexToRgb(value) {
    var match = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(value || '');
    return match ? [parseInt(match[1], 16), parseInt(match[2], 16), parseInt(match[3], 16)] : [122, 147, 43];
  }

  function rgbToHex(red, green, blue) {
    return '#' + [red, green, blue].map(function (value) {
      return clampRgb(value).toString(16).padStart(2, '0');
    }).join('');
  }

  function rgbControlHtml(value, field) {
    var rgb = hexToRgb(value);
    return '<label><span>Bar colour (RGB)</span><span class="pmg__rgb-control" data-pmg-rgb-group>' +
      '<input type="hidden" data-pmg-product-text="' + field + '" value="' + escapeHtml(value) + '" data-pmg-rgb-value>' +
      '<input type="number" min="0" max="255" value="' + rgb[0] + '" data-pmg-rgb-channel="r" aria-label="Red">' +
      '<input type="number" min="0" max="255" value="' + rgb[1] + '" data-pmg-rgb-channel="g" aria-label="Green">' +
      '<input type="number" min="0" max="255" value="' + rgb[2] + '" data-pmg-rgb-channel="b" aria-label="Blue">' +
      '<input type="color" value="' + escapeHtml(value) + '" data-pmg-rgb-preview aria-label="Open bar colour picker"></span></label>';
  }

  function syncSharedRgbControl() {
    var hidden = formField('pdp_bar_color');
    var group = hidden && hidden.closest('label').querySelector('[data-pmg-rgb-group]');
    if (!hidden || !group) return;
    var rgb = hexToRgb(hidden.value);
    group.querySelector('[data-pmg-rgb-channel="r"]').value = rgb[0];
    group.querySelector('[data-pmg-rgb-channel="g"]').value = rgb[1];
    group.querySelector('[data-pmg-rgb-channel="b"]').value = rgb[2];
    group.querySelector('[data-pmg-rgb-preview]').value = hidden.value;
  }

  function renderProductOverrides() {
    var discounts = root.querySelector('[data-pmg-product-discounts]');
    var images = root.querySelector('[data-pmg-product-images]');
    var bars = root.querySelector('[data-pmg-product-bars]');
    var products = currentCreateType === 'product' ? selectedProducts : [];
    [discounts, images, bars].forEach(function (grid) {
      if (grid) grid.closest('fieldset').hidden = !products.length;
    });
    if (discounts) discounts.hidden = !productOverrides.discount || productOverrideCollapsed.discount;
    if (images) images.hidden = !productOverrides.banner || productOverrideCollapsed.banner;
    if (bars) bars.hidden = !productOverrides.promobar || productOverrideCollapsed.promobar;
    root.querySelectorAll('[data-pmg-collapse-overrides]').forEach(function (button) {
      var group = button.getAttribute('data-pmg-collapse-overrides');
      var labels = { discount: 'product discounts', banner: 'product banners', promobar: 'product promo bars' };
      button.hidden = !productOverrides[group];
      button.setAttribute('aria-expanded', productOverrideCollapsed[group] ? 'false' : 'true');
      var action = productOverrideCollapsed[group] ? 'Expand ' : 'Collapse ';
      button.textContent = productOverrideCollapsed[group] ? '+' : '−';
      button.setAttribute('aria-label', action + labels[group]);
      button.setAttribute('title', action + labels[group]);
    });

    if (discounts) discounts.innerHTML = (productOverrides.discount ? products : []).map(function (product, index) {
      // Just the product name: appending "- discount percent" to every long
      // German product title wrapped some labels to two lines and not others,
      // which knocked the inputs out of alignment across the row.
      return '<label><span>' + escapeHtml(product.title) + '</span>' +
        '<input type="number" min="0" max="100" step="0.1" data-pmg-product-discount="' + index +
        '" value="' + escapeHtml(product.discountOverride || '') + '" placeholder="Use shared price rule"' +
        ' aria-label="Discount percent for ' + escapeHtml(product.title) + '"></label>';
    }).join('');

    if (images) images.innerHTML = (productOverrides.banner ? products : []).map(function (product, index) {
      var material = product.imageOverride;
      return '<div class="pmg__material-card" data-pmg-product-card="' + index + '"><h4>' + escapeHtml(product.title) + '</h4>' +
        (material ? '<p class="pmg__card-note pmg__card-note--saved">Saved image: ' + escapeHtml(materialTitle(material)) + '</p>' +
          (material.previewUrl ? '<img class="pmg__override-preview" src="' + escapeHtml(material.previewUrl) + '" alt="Selected banner">' : '') : '<p class="pmg__card-note">Uses the shared PDP banner, if selected.</p>') +
        '<label><span>Choose a different uploaded banner</span><input type="search" data-pmg-product-material-search placeholder="Search Shopify files"></label>' +
        '<div data-pmg-product-material-results></div>' +
        '<div class="pmg__product-upload"><span class="pmg__product-upload-label">Or upload a different banner</span>' +
        '<label class="pmg__upload-btn pmg__product-upload-button"><span>Choose image</span>' +
        '<input type="file" accept="image/*" data-pmg-product-upload aria-label="Upload banner for ' + escapeHtml(product.title) + '"></label></div>' +
        // Only offered once this product actually has its own banner - there is
        // nothing to undo otherwise, and a full-width button saying "use shared"
        // read like the section's main action rather than a per-card reset.
        (material ? '<button type="button" class="pmg__secondary-btn pmg__card-reset" data-pmg-product-image-clear>Remove this banner</button>' : '') +
        '<p role="status" data-pmg-product-image-status></p>' +
        '<p class="pmg__hint">Empty text fields use the shared values.</p>' +
        overrideTextFields(product, PRODUCT_BANNER_FIELDS) + '</div>';
    }).join('');

    if (bars) bars.innerHTML = (productOverrides.promobar ? products : []).map(function (product, index) {
      return '<div class="pmg__material-card" data-pmg-product-card="' + index + '"><h4>' + escapeHtml(product.title) + '</h4>' +
        '<p class="pmg__hint">Empty fields use the shared promo bar values.</p>' +
        overrideTextFields(product, PRODUCT_BAR_FIELDS) + '</div>';
    }).join('');
  }

  createForm.addEventListener('input', function (event) {
    if (event.target.matches('[data-pmg-rgb-channel]')) {
      var group = event.target.closest('[data-pmg-rgb-group]');
      var hidden = group && (group.querySelector('[data-pmg-rgb-value]') || group.closest('label').querySelector('[data-pmg-rgb-value]'));
      if (hidden) {
        var color = rgbToHex(
          group.querySelector('[data-pmg-rgb-channel="r"]').value,
          group.querySelector('[data-pmg-rgb-channel="g"]').value,
          group.querySelector('[data-pmg-rgb-channel="b"]').value
        );
        hidden.value = color;
        var preview = group.querySelector('[data-pmg-rgb-preview]');
        if (preview) preview.value = color;
        if (hidden.matches('[data-pmg-product-text]')) {
          var rgbProduct = productForCard(hidden.closest('[data-pmg-product-card]'));
          if (rgbProduct) {
            rgbProduct.textOverrides = rgbProduct.textOverrides || {};
            rgbProduct.textOverrides[hidden.getAttribute('data-pmg-product-text')] = color;
          }
        }
      }
    }
    if (event.target.matches('[data-pmg-rgb-preview]')) {
      var pickerGroup = event.target.closest('[data-pmg-rgb-group]');
      var pickerHidden = pickerGroup && (pickerGroup.querySelector('[data-pmg-rgb-value]') || pickerGroup.closest('label').querySelector('[data-pmg-rgb-value]'));
      if (pickerHidden) {
        var pickerColor = event.target.value.toLowerCase();
        var pickerRgb = hexToRgb(pickerColor);
        pickerHidden.value = pickerColor;
        pickerGroup.querySelector('[data-pmg-rgb-channel="r"]').value = pickerRgb[0];
        pickerGroup.querySelector('[data-pmg-rgb-channel="g"]').value = pickerRgb[1];
        pickerGroup.querySelector('[data-pmg-rgb-channel="b"]').value = pickerRgb[2];
        if (pickerHidden.matches('[data-pmg-product-text]')) {
          var pickerProduct = productForCard(pickerHidden.closest('[data-pmg-product-card]'));
          if (pickerProduct) {
            pickerProduct.textOverrides = pickerProduct.textOverrides || {};
            pickerProduct.textOverrides[pickerHidden.getAttribute('data-pmg-product-text')] = pickerColor;
          }
        }
      }
    }
    if (event.target.matches('[data-pmg-product-text]')) {
      var card = productImageCard(event);
      var targetProduct = productForCard(card);
      if (targetProduct) {
        targetProduct.textOverrides = targetProduct.textOverrides || {};
        targetProduct.textOverrides[event.target.getAttribute('data-pmg-product-text')] = event.target.value;
      }
    }
    if (event.target.matches('[data-pmg-product-discount]')) {
      var product = selectedProducts[Number(event.target.getAttribute('data-pmg-product-discount'))];
      if (product) product.discountOverride = event.target.value;
    }
  });

  function productImageCard(event) {
    return event.target.closest('[data-pmg-product-card]');
  }

  function productForCard(card) {
    return card ? selectedProducts[Number(card.getAttribute('data-pmg-product-card'))] : null;
  }

  createForm.addEventListener('change', function (event) {
    if (!event.target.matches('[data-pmg-override-toggle]')) return;
    var group = event.target.getAttribute('data-pmg-override-toggle');
    productOverrides[group] = event.target.checked;
    if (event.target.checked) productOverrideCollapsed[group] = false;
    // Values left behind by a collapsed section would still be saved while
    // being invisible, so unticking discards them.
    if (!event.target.checked) clearProductOverrides(group);
    renderProductOverrides();
  });

  createForm.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pmg-collapse-overrides]');
    if (!button) return;
    var group = button.getAttribute('data-pmg-collapse-overrides');
    productOverrideCollapsed[group] = !productOverrideCollapsed[group];
    renderProductOverrides();
  });

  function clearProductOverrides(group) {
    selectedProducts.forEach(function (product) {
      if (group === 'discount') {
        delete product.discountOverride;
        return;
      }
      if (group === 'banner') {
        delete product.imageOverride;
        // Bumped so an upload still in flight is discarded when it lands.
        product.imageRevision = (product.imageRevision || 0) + 1;
      }
      var fields = group === 'banner' ? PRODUCT_BANNER_FIELDS : PRODUCT_BAR_FIELDS;
      fields.forEach(function (field) {
        if (product.textOverrides) delete product.textOverrides[field[0]];
      });
    });
  }

  function resetProductOverrideToggles() {
    productOverrides = { discount: false, banner: false, promobar: false };
    productOverrideCollapsed = { discount: true, banner: true, promobar: true };
    root.querySelectorAll('[data-pmg-override-toggle]').forEach(function (toggle) {
      toggle.checked = false;
    });
  }

  function searchProductMaterials(event) {
    var input = event.target;
    if (!input.matches('[data-pmg-product-material-search]')) return;
    var card = productImageCard(event);
    var results = card.querySelector('[data-pmg-product-material-results]');
    var term = input.value;
    clearTimeout(input.searchTimer);
    input.searchTimer = setTimeout(function () {
      results.textContent = 'Loading uploaded banners…';
      fetchMaterials(term, 'pdp').then(function (data) {
        if (!card.isConnected || input.value !== term) return;
        card.materials = data.materials || [];
        results.innerHTML = card.materials.map(function (material, index) {
          return '<button type="button" class="pmg__picker-result" data-pmg-product-material="' + index + '">' +
            (material.previewUrl ? '<img src="' + escapeHtml(material.previewUrl) + '" alt="">' : '') +
            '<span>' + escapeHtml(materialTitle(material)) + '</span></button>';
        }).join('') || '<p>No matching files.</p>';
      }).catch(function (error) { results.textContent = error.message; });
    }, 250);
  }
  createForm.addEventListener('input', searchProductMaterials);
  createForm.addEventListener('focusin', searchProductMaterials);
  createForm.addEventListener('click', function (event) {
    var card = productImageCard(event);
    if (!card) return;
    var product = productForCard(card);
    var pick = event.target.closest('[data-pmg-product-material]');
    if (pick) product.imageOverride = card.materials[Number(pick.getAttribute('data-pmg-product-material'))];
    else if (event.target.closest('[data-pmg-product-image-clear]')) delete product.imageOverride;
    else return;
    product.imageRevision = (product.imageRevision || 0) + 1;
    renderProductOverrides();
  });
  createForm.addEventListener('change', function (event) {
    if (!event.target.matches('[data-pmg-product-upload]')) return;
    var card = productImageCard(event);
    var product = productForCard(card);
    var file = event.target.files[0];
    if (!file) return;
    var status = card.querySelector('[data-pmg-product-image-status]');
    var body = new FormData();
    body.append('file', file);
    var revision = product.imageRevision = (product.imageRevision || 0) + 1;
    pendingProductUploads += 1;
    status.textContent = 'Uploading…';
    api('/uploads', { method: 'POST', body: body }).then(function (data) {
      if (product.imageRevision !== revision) return;
      product.imageOverride = { id: data.id, title: file.name, previewUrl: data.previewUrl };
      if (selectedProducts.indexOf(product) !== -1) renderProductOverrides();
    }).catch(function (error) {
      status.textContent = 'Upload failed: ' + error.message;
    }).then(function () { pendingProductUploads -= 1; });
  });

  function validateProductOverrides() {
    if (pendingProductUploads) {
      showError(createError, 'Wait for the image uploads to finish before saving.');
      return false;
    }
    if (currentCreateType !== 'product' || editingPromotion) return true;
    var inputs = root.querySelectorAll('[data-pmg-product-discount], [data-pmg-product-text]');
    for (var index = 0; index < inputs.length; index += 1) {
      if (!inputs[index].checkValidity()) {
        setCreateStep(inputs[index].matches('[data-pmg-product-discount]') ? 1 : 3);
        inputs[index].reportValidity();
        return false;
      }
    }
    return true;
  }

  function renderSelectedProducts() {
    renderProductOverrides();
    if (currentCreateType !== 'product') {
      if (selectedProductsEl) selectedProductsEl.innerHTML = '';
      if (variantPicker) variantPicker.hidden = true;
      if (createCountLabel) createCountLabel.textContent = '';
      return;
    }
    if (!selectedProducts.length) {
      selectedProductsEl.innerHTML = '<p class="pmg__picker-empty">No products selected yet.</p>';
    } else {
      selectedProductsEl.innerHTML = selectedProducts.map(function (product, index) {
        return '<span class="pmg__chip">' +
          (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="">' : '<span class="pmg__chip-noimg"></span>') +
          '<span>' + escapeHtml(product.title) + '</span>' +
          '<button type="button" data-pmg-remove-product="' + index + '" aria-label="Remove ' + escapeHtml(product.title) + '">&times;</button>' +
          '</span>';
      }).join('');
    }
    if (selectedProducts.length !== 1 && selectedVariant) selectedVariant = null;
    if (variantPicker) variantPicker.hidden = currentCreateType !== 'product' || selectedProducts.length !== 1;
    renderSelectedVariant();
    createCountLabel.textContent = selectedProducts.length > 1 ? ' (' + selectedProducts.length + ' products)' : '';
    if (selectedProducts.length && currentCreateStep === 0) clearError(createError);
  }

  function renderSelectedVariant() {
    if (variantIdField) variantIdField.value = selectedVariant && selectedVariant.id ? selectedVariant.id : '';
    if (variantSkuField) variantSkuField.value = selectedVariant && selectedVariant.sku ? selectedVariant.sku : '';
    if (!selectedVariantEl) return;
    if (!selectedProducts.length || selectedProducts.length !== 1) {
      selectedVariantEl.innerHTML = '';
      return;
    }
    if (!selectedVariant) {
      selectedVariantEl.innerHTML = '<p class="pmg__picker-empty">All variants selected.</p>';
      return;
    }
    var title = selectedVariant.title || selectedVariant.sku || selectedVariant.id || 'Selected variant';
    var meta = selectedVariant.sku ? 'SKU ' + selectedVariant.sku : selectedVariant.id;
    selectedVariantEl.innerHTML = '<span class="pmg__chip pmg__chip--variant">' +
      '<span class="pmg__chip-noimg"></span>' +
      '<span>' + escapeHtml(title) + '<small>' + escapeHtml(meta) + '</small></span>' +
      '<button type="button" data-pmg-clear-variant aria-label="Use all variants">&times;</button>' +
      '</span>';
  }

  function renderProductResults(products) {
    var selectedHandles = selectedProducts.map(function (product) { return product.handle; });
    latestSearchResults = products.filter(function (product) { return selectedHandles.indexOf(product.handle) === -1; });

    if (!latestSearchResults.length) {
      productResultsEl.innerHTML = '<p class="pmg__picker-empty">No matching products.</p>';
      productResultsEl.hidden = false;
      return;
    }

    productResultsEl.innerHTML = latestSearchResults.map(function (product, index) {
      var statusNote = product.status && product.status !== 'ACTIVE' ? ' &middot; ' + escapeHtml(product.status.toLowerCase()) : '';
      return '<button type="button" class="pmg__picker-result" data-pmg-pick-product="' + index + '">' +
        (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="">' : '<span class="pmg__chip-noimg"></span>') +
        '<span>' + escapeHtml(product.title) + '<small>' + escapeHtml(product.handle) + statusNote + '</small></span>' +
        '</button>';
    }).join('');
    productResultsEl.hidden = false;
  }

  var searchDebounceTimer;
  function searchProducts(term) {
    api('/products?q=' + encodeURIComponent(term))
      .then(function (data) { renderProductResults(data.products || []); })
      .catch(function () { productResultsEl.hidden = true; });
  }

  function renderVariantResults(variants) {
    latestVariantResults = variants || [];
    if (!variantResultsEl) return;

    if (!latestVariantResults.length) {
      variantResultsEl.innerHTML = '<p class="pmg__picker-empty">No matching variants.</p>';
      variantResultsEl.hidden = false;
      return;
    }

    variantResultsEl.innerHTML = latestVariantResults.map(function (variant, index) {
      var meta = variant.sku ? 'SKU ' + variant.sku : variant.id;
      return '<button type="button" class="pmg__picker-result" data-pmg-pick-variant="' + index + '">' +
        '<span class="pmg__chip-noimg"></span>' +
        '<span>' + escapeHtml(variant.title || 'Variant') + '<small>' + escapeHtml(meta) + '</small></span>' +
        '</button>';
    }).join('');
    variantResultsEl.hidden = false;
  }

  var variantSearchDebounceTimer;
  function searchVariants(term) {
    if (!selectedProducts.length || selectedProducts.length !== 1 || !selectedProducts[0].handle) return;
    api('/products/' + encodeURIComponent(selectedProducts[0].handle) + '/variants?q=' + encodeURIComponent(term || ''))
      .then(function (data) { renderVariantResults(data.variants || []); })
      .catch(function () {
        if (variantResultsEl) variantResultsEl.hidden = true;
      });
  }

  productSearchInput.addEventListener('input', function () {
    clearTimeout(searchDebounceTimer);
    var term = productSearchInput.value;
    searchDebounceTimer = setTimeout(function () { searchProducts(term); }, 250);
  });

  productSearchInput.addEventListener('focus', function () {
    searchProducts(productSearchInput.value);
  });

  document.addEventListener('click', function (event) {
    if (event.target === productSearchInput || productResultsEl.contains(event.target)) return;
    productResultsEl.hidden = true;
  });

  if (variantSearchInput) {
    variantSearchInput.addEventListener('input', function () {
      clearTimeout(variantSearchDebounceTimer);
      var term = variantSearchInput.value;
      variantSearchDebounceTimer = setTimeout(function () { searchVariants(term); }, 250);
    });

    variantSearchInput.addEventListener('focus', function () {
      searchVariants(variantSearchInput.value);
    });
  }

  document.addEventListener('click', function (event) {
    if (!variantResultsEl || !variantSearchInput) return;
    if (event.target === variantSearchInput || variantResultsEl.contains(event.target)) return;
    variantResultsEl.hidden = true;
  });

  if (variantResultsEl) {
    variantResultsEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pmg-pick-variant]');
      if (!button) return;
      var variant = latestVariantResults[Number(button.getAttribute('data-pmg-pick-variant'))];
      if (variant) {
        selectedVariant = variant;
        renderSelectedVariant();
      }
      if (variantSearchInput) variantSearchInput.value = '';
      variantResultsEl.hidden = true;
    });
  }

  productResultsEl.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pmg-pick-product]');
    if (!button) return;
    var product = latestSearchResults[Number(button.getAttribute('data-pmg-pick-product'))];
    if (product) {
      selectedProducts.push(product);
      if (selectedProducts.length !== 1) selectedVariant = null;
      renderSelectedProducts();
    }
    productSearchInput.value = '';
    productResultsEl.hidden = true;
  });

  selectedProductsEl.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pmg-remove-product]');
    if (!button) return;
    selectedProducts.splice(Number(button.getAttribute('data-pmg-remove-product')), 1);
    renderSelectedProducts();
  });

  if (selectedVariantEl) {
    selectedVariantEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pmg-clear-variant]');
      if (!button) return;
      selectedVariant = null;
      renderSelectedVariant();
    });
  }

  // ---------------------------------------------------------------------
  // PDP promotion banner image upload
  // ---------------------------------------------------------------------

  function resetPdpImage() {
    pdpImagePreview.hidden = true;
    pdpImagePreview.querySelector('img').src = '';
    pdpImageStatus.textContent = '';
    pdpImageInput.value = '';
    var pdpInput = materialInput('pdp_image');
    var pdpSelected = materialSelectedEl('pdp_image');
    if (pdpInput) pdpInput.value = '';
    if (pdpSelected) pdpSelected.innerHTML = '';
  }

  function showPdpImagePreview(src, statusText) {
    var previewImg = pdpImagePreview.querySelector('img');
    previewImg.src = src;
    pdpImagePreview.hidden = false;
    pdpImageStatus.textContent = statusText || 'Image selected';
  }

  pdpImageInput.addEventListener('change', function () {
    var file = pdpImageInput.files && pdpImageInput.files[0];
    if (!file) return;

    pdpImagePreview.hidden = true;
    pdpImageStatus.textContent = 'Uploading...';
    pendingProductUploads += 1;

    var formData = new FormData();
    formData.append('file', file);

    api('/uploads', { method: 'POST', body: formData })
      .then(function (data) {
        setMaterialField('pdp_image', {
          id: data.id,
          title: file.name || 'Uploaded PDP banner',
          previewUrl: data.previewUrl || URL.createObjectURL(file),
        }, 'Uploaded');
        if (data.status && data.status !== 'READY') pdpImageStatus.textContent = 'Uploaded, processing on Shopify';
      })
      .catch(function (error) {
        pdpImageStatus.textContent = 'Upload failed: ' + error.message;
        pdpImageInput.value = '';
      }).then(function () { pendingProductUploads -= 1; });
  });

  pdpImageRemoveButton.addEventListener('click', resetPdpImage);

  Array.prototype.forEach.call(materialUploadInputs, function (input) {
    input.addEventListener('change', function () {
      var field = input.getAttribute('data-pmg-material-upload');
      var status = root.querySelector('[data-pmg-material-upload-status="' + field + '"]');
      var file = input.files && input.files[0];
      if (!field || !file) return;

      if (status) status.textContent = 'Uploading...';
      pendingProductUploads += 1;
      var formData = new FormData();
      formData.append('file', file);

      api('/uploads', { method: 'POST', body: formData })
        .then(function (data) {
          setMaterialField(field, {
            id: data.id,
            title: file.name || 'Uploaded image',
            previewUrl: data.previewUrl || URL.createObjectURL(file),
          }, 'Uploaded');
          if (status) status.textContent = data.status && data.status !== 'READY'
            ? 'Uploaded, processing on Shopify'
            : 'Uploaded';
        })
        .catch(function (error) {
          if (status) status.textContent = 'Upload failed: ' + error.message;
          input.value = '';
        })
        .then(function () { pendingProductUploads -= 1; });
    });
  });

  function showMaterialMessage(field, message) {
    var resultsEl = materialResultsEl(field);
    if (!resultsEl) return;
    resultsEl.innerHTML = '<p class="pmg__picker-empty">' + escapeHtml(message) + '</p>';
    resultsEl.hidden = false;
  }

  function renderMaterialResults(field, materials) {
    var resultsEl = materialResultsEl(field);
    latestMaterialResults[field] = materials || [];
    if (!resultsEl) return;

    if (!latestMaterialResults[field].length) {
      resultsEl.innerHTML = '<p class="pmg__picker-empty">No matching files.</p>';
      resultsEl.hidden = false;
      return;
    }

    resultsEl.innerHTML = latestMaterialResults[field].map(function (material, index) {
      var title = materialTitle(material);
      var details = [];
      if (material.filename && material.filename !== title) details.push(material.filename);
      if (material.width && material.height) details.push(material.width + 'x' + material.height);
      if (material.createdAt) details.push('Uploaded ' + formatDate(material.createdAt));
      var meta = details.length ? details.join(' · ') : material.status || 'Shopify File';
      return '<button type="button" class="pmg__picker-result pmg__material-result" data-pmg-pick-material="' + escapeHtml(field) + '" data-pmg-material-index="' + index + '">' +
        (material.previewUrl ? '<img src="' + escapeHtml(material.previewUrl) + '" alt="">' : '<span class="pmg__chip-noimg"></span>') +
        '<span>' + escapeHtml(title) + '<small>' + escapeHtml(meta) + '</small></span>' +
        '</button>';
    }).join('');
    resultsEl.hidden = false;
  }

  var materialSearchDebounceTimers = {};
  function fetchMaterials(term, category) {
    var query = '?q=' + encodeURIComponent(term || '') + '&category=' + encodeURIComponent(category || 'all');
    return api('/materials' + query).catch(function (error) {
      if (/not found/i.test(error.message)) return api('/promo-materials' + query);
      throw error;
    });
  }

  function searchMaterials(field, term, showLoading) {
    if (showLoading !== false) showMaterialMessage(field, 'Loading uploaded materials...');
    var category = materialCategory(field);
    fetchMaterials(term, category)
      .then(function (data) {
        latestMaterialCategories[field] = category;
        renderMaterialResults(field, data.materials || []);
      })
      .catch(function () {
        showMaterialMessage(field, 'Could not load uploaded files. Check Worker deploy and Shopify file permissions.');
      });
  }

  Array.prototype.forEach.call(materialSearchInputs, function (input) {
    var field = input.getAttribute('data-pmg-material-search');
    input.addEventListener('input', function () {
      showMaterialMessage(field, 'Loading uploaded materials...');
      clearTimeout(materialSearchDebounceTimers[field]);
      materialSearchDebounceTimers[field] = setTimeout(function () {
        searchMaterials(field, input.value, false);
      }, 250);
    });
    input.addEventListener('focus', function () {
      var hasCachedResults = latestMaterialCategories[field] === materialCategory(field) && latestMaterialResults[field] && latestMaterialResults[field].length;
      if (hasCachedResults) {
        renderMaterialResults(field, latestMaterialResults[field]);
      } else {
        showMaterialMessage(field, 'Loading uploaded materials...');
      }
      searchMaterials(field, input.value, !hasCachedResults);
    });
  });

  Array.prototype.forEach.call(materialCategoryInputs, function (input) {
    var field = input.getAttribute('data-pmg-material-category');
    input.addEventListener('change', function () {
      var searchInput = materialSearchInput(field);
      latestMaterialResults[field] = [];
      latestMaterialCategories[field] = '';
      showMaterialMessage(field, 'Loading uploaded materials...');
      searchMaterials(field, searchInput ? searchInput.value : '', false);
    });
  });

  document.addEventListener('click', function (event) {
    var materialResult = event.target.closest('[data-pmg-pick-material]');
    if (materialResult) {
      var field = materialResult.getAttribute('data-pmg-pick-material');
      var material = (latestMaterialResults[field] || [])[Number(materialResult.getAttribute('data-pmg-material-index'))];
      if (material) setMaterialField(field, material, 'Selected existing material');
      var searchInput = materialSearchInput(field);
      var resultsEl = materialResultsEl(field);
      if (searchInput) searchInput.value = '';
      if (resultsEl) resultsEl.hidden = true;
      return;
    }

    var clearButton = event.target.closest('[data-pmg-clear-material]');
    if (clearButton) {
      var clearField = clearButton.getAttribute('data-pmg-clear-material');
      if (clearField === 'pdp_image') resetPdpImage();
      else setMaterialField(clearField, null);
      return;
    }

    Array.prototype.forEach.call(materialSearchInputs, function (input) {
      var field = input.getAttribute('data-pmg-material-search');
      var resultsEl = materialResultsEl(field);
      if (!resultsEl) return;
      if (event.target === input || resultsEl.contains(event.target)) return;
      resultsEl.hidden = true;
    });
  });

  // ---------------------------------------------------------------------
  // Auth + promotions CRUD
  // ---------------------------------------------------------------------

  loginForm.addEventListener('submit', function (event) {
    event.preventDefault();
    clearError(loginError);
    var formData = new FormData(loginForm);
    api('/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ passphrase: formData.get('passphrase') }),
    })
      .then(function (data) {
        localStorage.setItem(TOKEN_STORAGE_KEY, data.token);
        loginForm.reset();
        showLoggedIn();
      })
      .catch(function (error) {
        showError(loginError, error.message);
      });
  });

  Array.prototype.forEach.call(viewButtons, function (button) {
    button.addEventListener('click', function () {
      var view = button.getAttribute('data-pmg-view-button');
      if (view === 'create') resetCreateForm();
      setAppView(view, view === 'promotions');
    });
  });

  Array.prototype.forEach.call(promotionFilterButtons, function (button) {
    button.addEventListener('click', function () {
      currentPromotionFilter = button.getAttribute('data-pmg-filter') || 'current';
      Array.prototype.forEach.call(promotionFilterButtons, function (filterButton) {
        var isActive = filterButton === button;
        filterButton.classList.toggle('is-active', isActive);
        filterButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      renderPromotions(currentPromotions);
    });
  });

  if (homeButton) {
    homeButton.addEventListener('click', function () {
      // Disabled while logged out, where there is no list to go back to.
      if (contentView.hidden) return;
      resetCreateForm();
      setAppView('promotions', true);
    });
  }

  Array.prototype.forEach.call(typePickButtons, function (button) {
    button.addEventListener('click', function () {
      setCreateType(button.getAttribute('data-pmg-pick-type'));
      setCreateStep(0);
      showTypePicker(false);
    });
  });

  Array.prototype.forEach.call(openCreateButtons, function (button) {
    button.addEventListener('click', function () {
      resetCreateForm();
      setAppView('create', false);
    });
  });

  if (prevStepButton) {
    prevStepButton.addEventListener('click', function () {
      if (currentCreateStep === 0 && !editingPromotion) {
        if (!window.confirm('Go back to the promotion types? You will lose all your progress on this promotion.')) return;
        resetCreateForm();
        return;
      }
      setCreateStep(currentCreateStep - 1);
    });
  }

  if (nextStepButton) {
    nextStepButton.addEventListener('click', function () {
      if (validateCreateStep(currentCreateStep)) setCreateStep(currentCreateStep + 1);
    });
  }

  Array.prototype.forEach.call(stepIndicators, function (indicator) {
    indicator.addEventListener('click', function () {
      var requestedStep = Number(indicator.getAttribute('data-pmg-step-indicator'));
      if (requestedStep <= currentCreateStep) {
        setCreateStep(requestedStep);
        return;
      }
      for (var stepIndex = currentCreateStep; stepIndex < requestedStep; stepIndex += 1) {
        if (!validateCreateStep(stepIndex)) {
          setCreateStep(stepIndex);
          return;
        }
      }
      setCreateStep(requestedStep);
    });
  });

  refreshButton.addEventListener('click', loadPromotions);

  function fieldsForCreateType(type) {
    if (type === 'homepage') return COMMON_PROMO_FIELDS.concat(HOMEPAGE_FIELDS);
    if (type === 'sales') return COMMON_PROMO_FIELDS.concat(SALES_FIELDS);
    return COMMON_PROMO_FIELDS.concat(PRODUCT_PROMO_FIELDS);
  }

  function buildPromotionBody(includeEmptyFields) {
    var formData = new FormData(createForm);
    var keys = fieldsForCreateType(currentCreateType);
    var body = {};
    keys.forEach(function (key) {
      var value = formData.get(key);
      if (value !== null && (includeEmptyFields || String(value).trim() !== '')) body[key] = value;
    });

    if (currentCreateType === 'homepage' || currentCreateType === 'sales') {
      var barPrefix = currentCreateType === 'homepage' ? 'homepage' : 'sales';
      ['badge', 'text', 'color', 'text_color'].forEach(function (suffix) {
        var source = formField(barPrefix + '_ui_bar_' + suffix);
        var destination = 'pdp_bar_' + suffix;
        if (source && (includeEmptyFields || String(source.value || '').trim() !== '')) body[destination] = source.value;
      });
      var alignment = formField('homepage_text_alignment');
      var homepageOptions = { promotion_type: currentCreateType };
      if (currentCreateType === 'homepage') homepageOptions.homepage_text_alignment = alignment ? alignment.value : 'left';
      ['color', 'text_color'].forEach(function (suffix) {
        var colour = formField(barPrefix + '_ui_bar_' + suffix);
        if (colour && colour.value) homepageOptions['pdp_bar_' + suffix] = colour.value;
      });
      body.product_targets = JSON.stringify(homepageOptions);
    }

    ['start_at', 'end_at'].forEach(function (key) {
      if (body[key]) body[key] = zonedDateTimeLocalToIso(body[key], PROMO_TIME_ZONE);
    });

    if (includeEmptyFields) {
      if (currentCreateType !== 'product') {
        PRODUCT_PROMO_FIELDS.concat(['product_handle']).forEach(function (key) {
          if (currentCreateType === 'homepage' && /^pdp_bar_/.test(key)) return;
          body[key] = '';
        });
      }
      if (currentCreateType !== 'homepage') {
        HOMEPAGE_FIELDS.forEach(function (key) {
          if (/^pdp_bar_/.test(key)) return;
          body[key] = '';
        });
      }
      if (currentCreateType !== 'sales') {
        SALES_FIELDS.forEach(function (key) { body[key] = ''; });
      }
    }

    if (currentCreateType === 'product' && selectedProducts.length <= 1) {
      if (selectedProducts[0] && selectedProducts[0].handle) body.product_handle = selectedProducts[0].handle;
      if (selectedProducts.length !== 1) {
        delete body.variant_id;
        delete body.variant_sku;
      }
    } else {
      delete body.variant_id;
      delete body.variant_sku;
    }

    return body;
  }

  function validateDraftSave() {
    clearError(createError);
    var campaign = formField('campaign');
    if (campaign && !campaign.checkValidity()) {
      campaign.reportValidity();
      return false;
    }

    var fieldsToCheck = fieldsForCreateType(currentCreateType);
    for (var index = 0; index < fieldsToCheck.length; index += 1) {
      var field = formField(fieldsToCheck[index]);
      if (field && String(field.value || '').trim() !== '' && !field.checkValidity()) {
        field.reportValidity();
        return false;
      }
    }

    var startAt = formField('start_at');
    var endAt = formField('end_at');
    var startDate = startAt && startAt.value ? zonedDateTimeLocalToDate(startAt.value, PROMO_TIME_ZONE) : null;
    var endDate = endAt && endAt.value ? zonedDateTimeLocalToDate(endAt.value, PROMO_TIME_ZONE) : null;
    if (startDate && endDate) {
      if (endDate.getTime() <= startDate.getTime()) {
        showError(createError, 'End time must be after the start time.');
        endAt.focus();
        return false;
      }
      if (endDate.getTime() - startDate.getTime() < MIN_PROMOTION_DURATION_MS) {
        showError(createError, 'Promotion duration must be at least 2 minutes because the live scheduler checks every minute.');
        endAt.focus();
        return false;
      }
    }

    return true;
  }

  createForm.addEventListener('submit', function (event) {
    event.preventDefault();
    clearError(createError);

    if (readOnlyPromotion) return;
    if (!validateProductOverrides() || !validateDraftSave()) return;

    var baseBody = buildPromotionBody(Boolean(editingPromotion));
    if (editingPromotion) {
      CLEARABLE_FIELDS.forEach(function (key) {
        if (baseBody[key] === undefined) baseBody[key] = '';
      });
    }

    createSubmitButton.disabled = true;

    if (editingPromotion) {
      if (currentCreateType === 'product') {
        baseBody.product_targets = JSON.stringify(buildProductTargets(baseBody));
        // The promotion metaobject is already at Shopify's 40-field limit.
        // Bar colour therefore lives in each target inside product_targets.
        delete baseBody.pdp_bar_color;
        delete baseBody.pdp_bar_text_color;
      }

      var updateBody = Object.assign({}, baseBody);
      // Lets the worker refuse the save if someone else changed the promotion
      // after this editor loaded it, instead of silently overwriting them.
      if (editingPromotion.updatedAt) updateBody.expected_updated_at = editingPromotion.updatedAt;
      api('/promotions/' + encodeURIComponent(editingPromotion.id), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateBody),
      })
        .then(function () {
          resetCreateForm();
          setAppView('promotions', false);
          loadPromotions();
        })
        .catch(function (error) {
          showError(createError, error.message);
        })
        .then(function () {
          createSubmitButton.disabled = false;
        });
      return;
    }

    function buildProductTargets(sharedBody) {
      return selectedProducts.map(function (product) {
        var target = { product_handle: product.handle, title: product.title || product.handle };
        if (product.discountOverride !== undefined && product.discountOverride !== '') target.discount_percent = product.discountOverride;
        if (product.imageOverride) {
          target.pdp_image = product.imageOverride.id;
          target.pdp_image_title = materialTitle(product.imageOverride);
          if (product.imageOverride.previewUrl && !/^blob:/i.test(product.imageOverride.previewUrl)) {
            target.pdp_image_preview_url = product.imageOverride.previewUrl;
          }
        }
        PRODUCT_TEXT_OVERRIDES.forEach(function (field) {
          var value = product.textOverrides && product.textOverrides[field[0]];
          if (value && value.trim()) target[field[0]] = value.trim();
        });
        if (sharedBody.pdp_bar_color) {
          target.shared_pdp_bar_color = sharedBody.pdp_bar_color;
          if (!target.pdp_bar_color) target.pdp_bar_color = sharedBody.pdp_bar_color;
        }
        if (sharedBody.pdp_bar_text_color) {
          target.shared_pdp_bar_text_color = sharedBody.pdp_bar_text_color;
          if (!target.pdp_bar_text_color) target.pdp_bar_text_color = sharedBody.pdp_bar_text_color;
        }
        return target;
      });
    }

    if (currentCreateType === 'product' && selectedProducts.length) {
      baseBody.product_targets = JSON.stringify(buildProductTargets(baseBody));
      delete baseBody.product_handle;
      delete baseBody.pdp_bar_color;
      delete baseBody.pdp_bar_text_color;
    }
    var requests = [api('/promotions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(baseBody),
      }).then(function () { return {}; }, function (error) { return { error: error }; })];

    Promise.all(requests)
      .then(function (results) {
        var failed = results.filter(function (result) { return result.error; });
        if (failed.length) {
          showError(createError, 'Could not save promotion: ' + failed[0].error.message);
          return;
        }
        createForm.reset();
        syncSharedRgbControl();
        selectedProducts = [];
        selectedVariant = null;
        renderSelectedProducts();
        renderSelectedVariant();
        resetMaterials();
        resetPdpImage();
        setCreateStep(0);
        setAppView('promotions', false);
        loadPromotions();
      })
      .catch(function (error) {
        showError(createError, error.message + ' (some products in this batch may have already been created - check the list below.)');
      })
      .then(function () {
        createSubmitButton.disabled = false;
      });
  });

  function findPromotion(id) {
    return currentPromotions.filter(function (promotion) { return promotion.id === id; })[0] || null;
  }

  rowsBody.addEventListener('click', function (event) {
    var approveButton = event.target.closest('[data-pmg-approve]');
    var pauseButton = event.target.closest('[data-pmg-pause]');
    var cancelButton = event.target.closest('[data-pmg-cancel]');
    var deleteButton = event.target.closest('[data-pmg-delete]');
    var editTarget = event.target.closest('[data-pmg-edit-promotion]');
    var approveId = approveButton && approveButton.getAttribute('data-pmg-approve');
    var pauseId = pauseButton && pauseButton.getAttribute('data-pmg-pause');
    var cancelId = cancelButton && cancelButton.getAttribute('data-pmg-cancel');
    var deleteId = deleteButton && deleteButton.getAttribute('data-pmg-delete');

    if (approveId) {
      approveButton.disabled = true;
      api('/promotions/' + encodeURIComponent(approveId) + '/approve', { method: 'POST' })
        .then(loadPromotions)
        .catch(function (error) {
          window.alert('Could not publish: ' + error.message);
          approveButton.disabled = false;
        });
      return;
    }

    if (pauseId) {
      if (!window.confirm('Move this scheduled promotion back to draft?')) return;
      pauseButton.disabled = true;
      api('/promotions/' + encodeURIComponent(pauseId) + '/pause', { method: 'POST' })
        .then(loadPromotions)
        .catch(function (error) {
          window.alert('Could not pause: ' + error.message);
          pauseButton.disabled = false;
        });
      return;
    }

    if (cancelId) {
      var cancelPromotion = findPromotion(cancelId);
      var cancelMessage = cancelPromotion && cancelPromotion.status === 'active'
        ? 'End this active promotion now and roll back its price/material changes?'
        : 'Cancel this promotion? This cannot be undone.';
      if (!window.confirm(cancelMessage)) return;
      cancelButton.disabled = true;
      api('/promotions/' + encodeURIComponent(cancelId) + '/cancel', { method: 'POST' })
        .then(loadPromotions)
        .catch(function (error) {
          window.alert('Could not cancel: ' + error.message);
          cancelButton.disabled = false;
        });
      return;
    }

    if (deleteId) {
      if (!window.confirm('Delete this promotion permanently? This cannot be undone.')) return;
      deleteButton.disabled = true;
      api('/promotions/' + encodeURIComponent(deleteId) + '/delete', { method: 'POST' })
        .then(loadPromotions)
        .catch(function (error) {
          window.alert('Could not delete: ' + error.message);
          deleteButton.disabled = false;
        });
      return;
    }

    if (editTarget) {
      editPromotion(findPromotion(editTarget.getAttribute('data-pmg-edit-promotion')));
    }
  });

  rowsBody.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var editTarget = event.target.closest('tr[data-pmg-edit-promotion]');
    if (!editTarget) return;
    event.preventDefault();
    editPromotion(findPromotion(editTarget.getAttribute('data-pmg-edit-promotion')));
  });

  setCreateType('product', true);
  setCreateStep(0);
  setAppView('promotions', false);
  if (homeButton) homeButton.disabled = contentView.hidden;

  // On load, if a 12h session token from a previous visit is still in
  // localStorage, try it straight away and skip the login screen; if it's
  // expired the 401 falls through to showLoggedOut(). No stored token at
  // all means don't bother making a doomed request.
  if (localStorage.getItem(TOKEN_STORAGE_KEY)) {
    api('/promotions')
      .then(function (data) {
        showLoggedIn(true);
        renderPromotions(data.promotions || []);
      })
      .catch(function () {
        showLoggedOut();
      });
  } else {
    showLoggedOut();
  }
})();
